import { Box } from "@mui/joy";

// Спокойный синий градиент с лёгким акцентным свечением сверху (под именем/аватаром).
// Акцент проекта — #007AFF. Тёмный низ держит белый текст читаемым.
export default function BackgroundBlobs() {
    return (
        <Box sx={{
            position: 'absolute',
            inset: 0,
            zIndex: 0,
            background:
                'radial-gradient(120% 70% at 50% 0%, rgba(0, 122, 255, 0.55) 0%, rgba(0, 43, 99, 0) 60%), ' +
                'linear-gradient(160deg, #013A8A 0%, #001B3D 100%)',
        }} />
    );
}
